module.exports = __webpack_public_path__ + "static/media/lbintWhiteText.635e41b8.png";